import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding, Input, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import { ChartBarData } from '../..';

@Component({
  selector: 'f-stacked-bar',
  templateUrl: './stacked-bar.component.html',
  animations: [
    trigger('expandBar', [
      state('*', style({ width: '{{width}}%' }), { params: { width: 0 } }),
      transition('* <=> *', animate('{{duration}}ms {{delay}}ms ease-out'), { params: { duration: 0, delay: 0 } })
    ])
  ],
  standalone: false
})
export class FireflyStackedBarComponent implements OnChanges {
  @HostBinding('class') cssClass = 'd-block';

  @Input() thickness = 5;
  @Input() animation = false;
  @Input() animationDelay = 0;
  @Input() animationDuration = 500;
  @Input() popoverTemplate!: TemplateRef<unknown> | null;
  @Input() popoverTriggers = 'hover focus';
  @Input() popoverPlacement = 'top';
  @Input() containerClass!: string | string[];
  @Input() data: ChartBarData[] = [];
  @Input() barSegmentTemplate: TemplateRef<{ $implicit: number }> | null = null;

  popoverContextData: unknown[] = [];

  get transitionDurationFraction() {
    return this.data.length ? this.animationDuration / Math.sqrt(this.data.length) : 0;
  }

  get animationStates() {
    return this.data.map(item => `change-bar-width-to${item.percentage}`);
  }

  get totalWidth() {
    return this.data.map(item => item.percentage).reduce((acc, value) => acc + value);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.updateDerivedData();
    }
  }

  protected updateDerivedData() {
    this.popoverContextData = this.data.map(({ label, percentage, popoverData }) => ({
      label,
      percentage,
      popoverData
    }));
  }
}
